<div class="card">
  <h5 class="card-header h5">Bar Chart</h5>
  <div class="card-body row">
    <div style="display: block" class="mx-auto">
      <canvas id="liveSectionBarChart"> </canvas>
    </div>
  </div>
</div>
